export const REGEX = {
  EMAIL: '([A-Za-z0-9._%-]+@[A-Za-z0-9._%-]+\\.[a-z]{2,3})(,[ ]?([A-Za-z0-9._%-]+@[A-Za-z0-9._%-]+\\.[a-z]{2,3}))*',
  PHONE: '([0-9]{10})(,[ ]?([0-9]{10}))*',
  NUMERIC: /^[0-9]*$/,
  NIT: /^\d{5,12}-\d{1}$/
};
